const { cELM, guidGenerator, httpGet, get, Wrap4Arrow, getAnswerVariableCssClass } = require("../utils");
const { url } = require("../config");
const Scroller = require("../components/scroller");
const Chat = require("../chat");
const Provider = require("../components/blocks/provider");
const Question = require("../components/blocks/question");
const UploaderControl = require("./uploader-control");

class OcrModule {
  constructor(type, value) {
    this.type = type;
    this.value = value;
    this._files = null;
    this._timer = null;
    this.cardType = get(this.value, "values.meta.type", "");
    this.elements = {
      _questionBlock: null,
      _uploadContainerEl: null,
      _inputEl: null,
      _btnEl: null,
      _percentEl: null,
      _loadingBl: null,
    };

    const cssVariableKey = getAnswerVariableCssClass(value);
    this.getLanguage((value || {}).id);

    this.elContainer = cELM("div", `component-block upload ${cssVariableKey}`);
    this.elContainer.addELM(new Provider({ data: value }));

    let _qBl = null;
    if (get(value, "values.file.finalURL")) {
      _qBl = new Question({
        data: {
          text: get(value, "values.text.content", ""),
          subtext: get(value, "values.subtext"),
        },
      });
      this.elContainer.addELM(_qBl);
    } else {
      _qBl = new Question({ data: value });
      this.elContainer.addELM(_qBl);
    }
    this.elements._questionBlock = _qBl;

    const img = cELM("img", "license");
    if (get(value, "values.file.finalURL")) {
      img.src = get(value, "values.file.finalURL");
    } else {
      img.style.display = "none";
    }
    this.elContainer.addELM(img);
    this.elements._img = img;

    this.elContainer.addELM(this.addAnswerBlock());
    this.addProcessedForm();

    this.control = new UploaderControl({ delegate: this });
  }

  getLanguage(questionnaire) {
    if ((questionnaire || '').toLowerCase().indexOf("/spa/") > -1) {
      this.language = {
        continue: "Continuar",
        skip: "Omitir",
        takeOrUpload: "Tomar o subir imagen",
        retake: "Tomar nuevamente"
      };
    } else {
      this.language = {
        continue: "Continue",
        skip: "Skip",
        takeOrUpload: "Take or upload picture",
        retake: "Retake"
      };
    }
  }

  addProcessedForm() {
    var _continue = this.language.continue || "Continue";

    const fields = get(this.value, "values.meta.fields", []);
    const type = this.cardType;
    const formBl = cELM("div", "option-block form");

    const forms = ["gender", "street", "city", "state", "zip", "insurance-policy-number"];

    forms.forEach(function(fieldName) {
      const inputEl = cELM("input", "text-input");
      const labelEl = cELM("label", "", fieldName);
      inputEl.name = fieldName;
      formBl.addELM(labelEl);
      formBl.addELM(inputEl);

      const field = fields.find(function(f) {
        return f.name === fieldName;
      });

      if (field) {
        inputEl.value = field.value.trim();
      } else {
        labelEl.style.display = "none";
        inputEl.style.display = "none";
      }
    });

    this.elContainer.addELM(formBl);
    this.elements._formBl = formBl;

    const _submitEl = Wrap4Arrow(
      cELM("div", "continue-button continue-button-active", _continue),
      true,
    );
    this.elContainer.addELM(_submitEl);

    const _self = this;
    _submitEl.onclick = function() {
      if (_self.cardType === "license") {
        Chat.default.send(
          {
            id: (_self.value || {}).id,
            meta: {
              fields: [
                {
                  name: "gender",
                  value: _self.getComponent("input[name='gender']").value,
                },
                {
                  name: "street",
                  value: _self.getComponent("input[name='street']").value,
                },
                {
                  name: "zip",
                  value: _self.getComponent("input[name='zip']").value,
                },
                {
                  name: "state",
                  value: _self.getComponent("input[name='state']").value,
                },
                {
                  name: "city",
                  value: _self.getComponent("input[name='city']").value,
                },
              ],
              gender: _self.getComponent("input[name='gender']").value,
              type: "license",
            },
            status: "processed-validated",
          },
          null,
          _self.elContainer,
        );
      } else if (_self.cardType === "insurance") {
        Chat.default.send(
          {
            id: (_self.value || {}).id,
            meta: {
              fields: [
                {
                  name: "insurance-policy-number",
                  value: _self.getComponent("input[name='insurance-policy-number']").value,
                },
              ],
              type: "insurance",
            },
            status: "processed-validated",
          },
          null,
          _self.elContainer,
        );
      } else {
        Chat.default.send(
          {
            id: (_self.value || {}).id,
            meta: {
              fields: [],
              type: "card-back",
            },
            status: "processed-validated",
          },
          null,
          _self.elContainer,
        );
      }

      _self.hideAnswers();
    };

    this.elements._submitEl = _submitEl;

    if (fields.length === 0) {
      _submitEl.style.display = "none";
      formBl.style.display = "none";
    }
  }

  fillForm(fields, type) {
    this.cardType = type;
    const _self = this;

    const forms =
      type === "license"
        ? ["gender", "street", "city", "state", "zip"]
        : ["insurance-policy-number"];

    forms.forEach(function(fieldName) {
      const field = fields.find(function(f) {
        return f.name === fieldName;
      });

      const el = _self.getComponent("input[name='" + fieldName + "']");
      if (!el) return;

      if (field && field.value) {
        el.value = field.value.trim();
        el.style.display = "block";
        el.previousSibling.style.display = "block";
      } else {
        el.style.display = "none";
        el.previousSibling.style.display = "none";
      }
    });
  }

  addAnswerBlock() {
    const _self = this;

    var retake = this.language.retake || "Retake";
    var takeOrUpload = this.language.takeOrUpload || "Take or upload picture";
    var skip = this.language.skip || "Skip";

    const oBlock = cELM("div", "option-block controls");
    const _btnEl = cELM(
      "div",
      "button",
      get(this.value, "values.file.finalURL") ? retake : takeOrUpload,
    );
    const _inputEl = cELM("input", "input-file");

    _inputEl.setAttribute("multiple", false);
    _inputEl.setAttribute("accept", "image/*,.pdf");
    _inputEl.setAttribute("type", "file");
    _inputEl.style.display = "none";

    const _uploadContainerEl = cELM("div", "inputs-wrapper");
    const _loadingBl = cELM("div", "loading-block");
    _loadingBl.style.display = "none";

    const _percentEl = cELM("div", "percent", "0%");
    _loadingBl.addELM(_percentEl);

    const _skipBtnEl = cELM("div", "button inactive", skip);
    const _row = cELM("div", "upload-actions");
    _row.addELM(cELM("div", "button blank"));
    _row.addELM(_btnEl);
    _row.addELM(_skipBtnEl);

    _uploadContainerEl.addELM(_loadingBl);
    _uploadContainerEl.addELM(_row);

    _skipBtnEl.onclick = function(evt) {
      clearTimeout(this._timer);
      Chat.default.send(
        {
          id: (_self.value || {}).id,
          meta: { type: "unknown", fields: [] },
          status: "processed-validated",
        },
        null,
        _self.elContainer,
      );
      _self.hideAnswers();
    };

    _inputEl.onchange = function(e) {
      if (this.files[0]) {
        _self._files = this.files;
        _self.control.queue(this);
        _self.control.processQueue();
      }
    };

    _btnEl.onclick = function(evt) {
      _inputEl.click();
    };

    oBlock.addELM(_uploadContainerEl);
    oBlock.addELM(_inputEl);
    // oBlock.addELM(_btnEl);

    this.elements._uploadContainerEl = _uploadContainerEl;
    this.elements._inputEl = _inputEl;
    this.elements._btnEl = _btnEl;
    this.elements._percentEl = _percentEl;
    this.elements._loadingBl = _loadingBl;

    return oBlock;
  }

  handle(value) {
    switch (value.format) {
      case "onfiletransfer-started":
        break;
      case "onfiletransfer-uploaded":
        this.handleUploaded(value);
        break;
      case "onfiletransfer-resized":
        clearTimeout(this._timer);
        this.handleResized(value);
        break;
      case "onfiletransfer-processed":
        clearTimeout(this._timer);
        this.handleProcessed(value);
        break;
      default:
        break;
    }
  }

  getELM() {
    return this.elContainer;
  }

  getHTML() {
    return this.elContainer;
  }

  reset() {}

  focus() {}

  scrollToElement() {
    Scroller.scrollToElm(this);
  }

  handleUploaded(value) {
    const h = value.values.name;
    const _self = this;

    this._maxPercent = 98;
    this._timer = setTimeout(function() {
      httpGet(url + "/api/image/status/completed/" + h, {}, function (result) {
        console.log(result);
      });
    }, 15000);

  }

  handleResized(value) {
    const _self = this;
    Chat.default.send({
      id: (_self.value || {}).id,
      hash: value.name,
      status: "process",
    });
  }

  handleProcessed(value) {
    // when upload completed and processed
    this._percent = 100;
    this._maxPercent = 100;
    clearInterval(this._interval);
    this.updateProgress();

    var retake = this.language.retake || "Retake";

    const qBl = new Question({
      data: {
        text: get(value, "values.text.content", ""),
        subtext: get(value, "values.subtext"),
      },
    });

    this.elements._questionBlock.elm.innerHTML = qBl.getHTML().innerHTML;
    this.elements._btnEl.style.display = "block";

    const img = this.getComponent("img.license");
    img.src = get(value, "values.file.finalURL");
    img.style.display = "block";

    this.elements._loadingBl.style.display = "none";
    this.getComponent("div.option-block.form").style.display = "block";
    this.getComponent("div.continue-button").parentNode.style.display = "block";
    this.elements._btnEl.innerHTML = retake;

    this.fillForm(get(value, "values.meta.fields", []), get(value, "values.meta.type"));
  }

  // callbacks
  onUpload(file) {
    const _self = this;
    // when upload starts
    // this.elements._uploadContainerEl.style.display = "block";
    this.elements._btnEl.style.display = "none";
    this.elements._loadingBl.style.display = "block";

    this.getComponent("img.license").style.display = "none";
    this.getComponent("div.continue-button").parentNode.style.display = "none";
    this.getComponent("div.continue-button").parentNode.previousSibling.style.display = "none";

    this._files[0].batchId = guidGenerator();
    Chat.default.send({
      id: (_self.value || {}).id,
      files: this._files,
      status: "start",
    });

    Scroller.scrollToEnd(0);
    this.initiateLoader();
  }

  onProgress(file, progress) {
    const _self = this;
    Chat.default.send({
      id: (_self.value || {}).id,
      file: { finalURL: file.finalURL, size: file.size,progress:progress },
      status: "uploading"
    });
  }

  onCompleted(file) {
    const _self = this;
    Chat.default.send(
      {
        id: (_self.value || {}).id,
        file: {
          finalURL: file.finalURL,
          mime: file.type,
          name: file.name,
          progress: 100,
          status: "completed",
        },
        status: "uploaded",
      },
      null,
      this.elContainer,
    );
  }

  onError(file, msg) {
    console.log(file, msg);
  }

  initiateLoader() {
    this._percent = 0;
    this._maxPercent = 30 + Math.floor(Math.random() * 30);

    const _self = this;

    this._interval = setInterval(function() {
      const inc = (_self._maxPercent - _self._percent) / 100;
      if (_self._percent < _self._maxPercent) {
        _self._percent += inc;
        _self.updateProgress();
      }

      if (_self.percent >= 100) {
        clearInterval(_self._interval);
      }
    }, 20);
  }

  updateProgress() {
    this.elements._percentEl.innerHTML = Math.round(this._percent) + "%";
  }

  hideAnswers() {
    this.getComponent(".option-block.controls").style.display = "none";
    this.getComponent(".option-block.form").style.display = "none";
    this.getComponent("div.continue-button").parentNode.style.display = "none";
  }

  getComponent(selector) {
    return this.elContainer.querySelector(selector);
  }
}

module.exports = OcrModule;
